export const API_BASE_URL  = process.env.REACT_APP_BASE_URL;
export const CMS_BASE_URL = process.env.REACT_APP_BASE_CMS_URL;
export const ASP_BASE_URL = process.env.REACT_APP_BASE_ASP_URL;